import { Calendar } from "lucide-react";

export const YearFilterBar = ({ years, selectedYear, onYearChange }) => {
  if (!years?.length) return null;

  return (
    <div
      className="flex items-center gap-2 overflow-x-auto pb-1"
      data-testid="year-filter-bar"
      style={{ scrollbarWidth: "none" }}
    >
      <div className="flex items-center gap-1.5 mr-2">
        <Calendar className="w-3.5 h-3.5 text-muted-foreground" />
        <span className="text-xs font-medium text-muted-foreground uppercase tracking-wide">
          Filter by year
        </span>
      </div>
      <button
        onClick={() => onYearChange(null)}
        className={`px-3 py-1 rounded-full text-xs font-medium transition-colors ${
          !selectedYear
            ? "bg-primary text-primary-foreground"
            : "bg-muted/40 text-muted-foreground hover:bg-muted"
        }`}
        data-testid="year-filter-all"
      >
        All Time
      </button>
      {years.map((y) => (
        <button
          key={y.year}
          onClick={() => onYearChange(y.year)}
          className={`px-3 py-1 rounded-full text-xs font-medium transition-colors ${
            selectedYear === y.year
              ? "bg-primary text-primary-foreground"
              : "bg-muted/40 text-muted-foreground hover:bg-muted"
          }`}
          data-testid={`year-filter-${y.year}`}
        >
          {y.year} <span className="opacity-60 ml-0.5">({y.count.toLocaleString()})</span>
        </button>
      ))}
    </div>
  );
};

export default YearFilterBar;
